import React from 'react';

import { IonText } from '@ionic/react';

import clsx from 'clsx';

import './index.css';
import { ITypography } from './interfaces';

export const Typography: React.FC<ITypography> = ({
  className,
  variant = 'body2',
  lineClamp = 3,
  color,
  inline = false,
  ...props
}) => {
  const colorClassName = color ? `ion-text-color-${color}` : '';
  return (
    <IonText
      title={'variant'}
      className={clsx(
        colorClassName,
        className,
        {
          ['inline']: inline,
          ['line-clamp']: lineClamp > 1,
          [`line-clamp-${lineClamp}`]: lineClamp,
          ['title']: variant === 'title',
          ['subtitle1']: variant === 'subtitle1',
          ['subtitle2']: variant === 'subtitle2',
          ['body2']: variant === 'body2',
          ['caption']: variant === 'caption',
          ['overline']: variant === 'overline',
        },
        'typography'
      )}
      {...props}
    />
  );
};
export default Typography;
